module.exports = __webpack_public_path__ + "img/icon_cyclogest.208a076a.png";